
import { EditedParticipation } from "../../../Partner/EditedPartner";
import { Filter } from "../../ParticipationFunctions/Filtering";
import { CellWithValidator, StickyHeader } from "../../../../components/Table/TableStyles";
import { offsetOneRow, offsetTwoRows, StateStyledCell } from "../../Styles/ParticipationTableStyles";
import { ValidatedIcon, ValidateFilter, ValidateFilterValue } from "../../../../components/Controls/ValidateControl";
import { TextFilter } from "../../../../components/Form/FormStyles";
import { formatYesNoConditional } from "../../../../entities";

export function ICROAEndorsedStandardHeader() {
	return (
		<StickyHeader
			style={{
				...offsetOneRow,
				width: '200px',
				minWidth: '200px',
				maxWidth: '200px'
			}}>
			CC ICROA Endorsed Standard
		</StickyHeader>
	)
}

export function ICROAEndorsedStandardFilter({ filter, updateFilter }: { filter: Filter, updateFilter: (filter: Filter) => void }) {
	return (
		<StickyHeader style={{ ...offsetTwoRows }}>
			<CellWithValidator>
				<ValidateFilter
					value={
						filter?.CarbonICroaEndorsedStandardValidated ??
						ValidateFilterValue.Unset
					}
					onChange={(e) =>
						updateFilter({
							...filter,
							CarbonICroaEndorsedStandardValidated: e.value
						})
					}
				/>
				<TextFilter
					value={filter?.CarbonICroaEndorsedStandard ?? ''}
					onChange={(e) =>
						updateFilter({
							...filter,
							CarbonICroaEndorsedStandard: e.target.value
						})
					}
				/>
			</CellWithValidator>
		</StickyHeader>
	)
}

export function ICROAEndorsedStandardContent({ ppn }: { ppn: EditedParticipation }) {
	return (
		<StateStyledCell
			editStatus={ppn.EditStatus}
			modified={ppn.PlantingProjectId.modified}>
			<CellWithValidator>
				<span>
					{ppn.PlantingProject.CarbonICroaEndorsedStandardValidated && (
						<ValidatedIcon />
					)}
				</span>
				<span>
					{formatYesNoConditional(
						ppn.PlantingProject.CarbonICroaEndorsedStandard
					)}
				</span>
			</CellWithValidator>
		</StateStyledCell>
	)
}